import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class PriorObOrGynInfections extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      PriorObGynInfectionsType: "",
      PriorObGynInfectionsTests: "",
      PriorObGynInfectionsTreatment: "",
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
   
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      var dict = {
        PriorObGynInfectionsType:
          this.state.tablevaluesglobal[i]["PriorObGynInfectionsType"],
        PriorObGynInfectionsTests:
          this.state.tablevaluesglobal[i]["PriorObGynInfectionsTests"],
        PriorObGynInfectionsTreatment:
          this.state.tablevaluesglobal[i]["PriorObGynInfectionsTreatment"],
      };
      this.setState({
        loading: true
      })
      axios
        .post(
          this.api_url+""+localStorage.getItem('currentModule')+"/previousinfections/main",
          dict,
          {
            headers: headers,
          }
        )
        .then((response) => {
          this.setState({
            loading: false
          });

          if (response.data["status"]) {
            $(".alert-success").show();
            // setTimeout(function () {
                window.location.href = '/medical/disorders'
            // }, 500);
          }
        })
        .catch((error) => {
          $('#SubmitError').fadeIn();
          console.log(error);
        });
    }
  };
  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();

    $(".proceed").click();
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.PriorObGynInfectionsType = data[i][0];
      trimobj.PriorObGynInfectionsTests = data[i][1];
      trimobj.PriorObGynInfectionsTreatment = data[i][2];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", ""]];

    const columns = ["Date and Time",  "Prior Ob Or GynInfection", "Exam Type", "Treatment"];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { patientName, loading } = this.state;

    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Prior Ob Or GynInfections
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Obstetrics History Saved
                Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PriorObOrGynInfections;
